import React from "react";
import { useEffect, useRef, useState, useMemo } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { isEmpty, getWindowDimensions, ByteLength, isEnabled, DicVal} from '../../modules/appLibrary';
import { arrayMove } from 'react-sortable-hoc';
import HinbanEntryInput from "./HinbanEntryInput";
import Tooltip from '@material-ui/core/Tooltip';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Paper from '@material-ui/core/Paper';
import { imageopen, setimagelist } from '../../modules/imagedlgstore';
import noimage from '../../Resources/noimage.jpg';

export default function HinbanEntryBase(props) {

    const images = useSelector(state => state.imgdlg.images);
    const formstatus = useSelector(state => state.form.status);
    const themestyle = useSelector(state => state.form.themestyle);
    const warndescription = useSelector(state => state.form.warndiscription);
    const rotChangeFlagValue = useSelector(state => {
        const source = state.form.entrydata;
        if (isEmpty(source)) return '';
        const flagKey = Object.keys(source).find((key) => {
            const token = String(isEmpty(key) ? '' : key).trim().toUpperCase();
            return token === 'ROTCHANGEFLG' || token.endsWith('ROTCHANGEFLG') || token.includes('ROTCHANGEFLG');
        }) || 'PDT_ROTCHANGEFLG';
        return String(isEmpty(source[flagKey]) ? '' : source[flagKey]).trim();
    });
    const fixedHinbanNumberingValue = useSelector(state => {
        const source = state.form.entrydata;
        if (isEmpty(source)) return '';
        const key = Object.keys(source).find((dataKey) => matchesColumnId(dataKey, '__hinban_numbering_select__')) || '__hinban_numbering_select__';
        return String(isEmpty(source[key]) ? '' : source[key]).trim();
    });
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [imgsrc, setimgsrc] = useState('');
    const [imgindex, setimgindex] = useState(0);
    const initialFocusTimerRef = useRef(null);
    const dispatch = useDispatch();
    const sectionLock = !!props.sectionLock;
    const effectiveFormStatus = props.forceNewFormMode ? 'NEW FORM' : formstatus;

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (initialFocusTimerRef.current !== null) {
            clearTimeout(initialFocusTimerRef.current);
            initialFocusTimerRef.current = null;
        }
        if (formstatus.indexOf("FORM") === -1) {
            if (props.initialFocusRef) props.initialFocusRef.current = "";
            return;
        }
        const focusToken = effectiveFormStatus + '_' + String(!!props.forceNewFormMode);
        if (props.initialFocusRef && props.initialFocusRef.current === focusToken) return;
        initialFocusTimerRef.current = setTimeout(() => {
            const active = document.activeElement;
            const activeTag = String(isEmpty(active) ? "" : active.tagName).toUpperCase();
            const activeEditable = !isEmpty(active) && (
                activeTag === "INPUT" ||
                activeTag === "TEXTAREA" ||
                activeTag === "SELECT" ||
                active.isContentEditable
            );
            if (activeEditable) {
                if (props.initialFocusRef) props.initialFocusRef.current = focusToken;
                initialFocusTimerRef.current = null;
                return;
            }
            var key = Firstcolumn();
            if (!isEmpty(key)) {
                try {
                    document.getElementById(key).focus();
                    document.getElementById(key).select();
                    if (props.initialFocusRef) props.initialFocusRef.current = focusToken;
                } catch (error) {
                    console.log(error);
                }
            }
            initialFocusTimerRef.current = null;
        }, 500);
        return () => {
            if (initialFocusTimerRef.current !== null) {
                clearTimeout(initialFocusTimerRef.current);
                initialFocusTimerRef.current = null;
            }
        };
    }, [effectiveFormStatus, props.forceNewFormMode, props.initialFocusRef, props.textfields]);

    useEffect(() => {
        if (isEmpty(images)) {
            setimgsrc(noimage); return;
        }
        if (images.length === 0) {
            setimgsrc(noimage); return;
        }
        setimgsrc(images[0].imageurl);
        setimgindex(0);
    }, [images]);

    function imageChange(index) {
        if (sectionLock) return;
        setimgsrc(images[index].imageurl);
        setimgindex(index);
    }
    function ImageDialog() {
        if (sectionLock) return;
        if (isEmpty(images)) return;
        if (images.length === 0) return;
        dispatch(imageopen({ images: images, default: images[imgindex].filename }));
    }

    function Firstcolumn() {
        if (isEmpty(props.textfields)) return "";
        if (props.textfields.length === 0) return "";
        return props.textfields[0].columnid + "_" + props.textfields[0].type;
    }
    function width(value) {
        var w = 0;
        var ratio = 1.33;
        if (windowDimensions.width <= 600) {
            w = 100;
        } else if (windowDimensions.width <= 800) {
            let size = [50, 50, 100, 100, 50, 60, 60, 60, 80];
            w = size[value];
            ratio = 2;
        } else if (windowDimensions.width <= 1000) {
            let size = [50, 50, 100, 100, 25, 40, 40, 60, 80];
            ratio = 2;
            w= size[value];
        } else if (windowDimensions.width <= 1500) {
            let size = [25, 50, 75, 100, 25, 20, 40, 60, 80];
            w = size[value];
        } else {
            let size = [25, 50, 75, 100, 12.5, 20, 40, 60, 80];
            w= size[value];
        }
        if (props.showimage) w *= ratio;
        if (w > 100) w = 100;
        return w.toString() + "%";
    }
    function ChangeWidth(def, deltaY) {
        let col = props.textfields.find(e => e.columnid === def.columnid && e.type === def.type);
        if (isEmpty(col)) return;
        if (deltaY > 0) {
            if (col.width === 0) return;
            col.width -= 1;
        } else {
            if (col.width === 3) return;
            col.width += 1;
        }
        props.settextfields({ ...props.textfields });
    }
    function warning(value) {
        if (warndescription.length === 0) return false;
        const warn = warndescription.find(e => e.rowid === "0" && e.col === value.columnid);
        if (!isEmpty(warn)) {
            return true;
        }
    }
   function WarnTip(param) {
        return (
            <Tooltip title={param.msg}>
                <div style={{ position: 'absolute', top: -2, left: -2, cursor: 'pointer' }}>
                    {param.conv ? < span class="material-icons convert">check_circle</span> : < span class="material-icons warning">announcement</span>}
                </div>
            </Tooltip>
        );
    }
    function labelfontsize(name) {
        var fs = ByteLength(name) > 16 ? '9px' : 'none';
        return fs;
    }
    function matchesColumnId(columnid, target) {
        return String(isEmpty(columnid) ? "" : columnid).trim().toUpperCase() === String(isEmpty(target) ? "" : target).trim().toUpperCase();
    }
    function matchesColumnToken(columnid, target) {
        const left = String(isEmpty(columnid) ? "" : columnid).trim().toUpperCase();
        const right = String(isEmpty(target) ? "" : target).trim().toUpperCase();
        return left === right || left.endsWith(right) || left.includes(right);
    }
    function currentRotChangeFlag() {
        if (!isEmpty(rotChangeFlagValue)) return rotChangeFlagValue;
        const source = props.entrydataRef.current;
        if (isEmpty(source)) return "";
        const flagKey = Object.keys(source).find((key) => matchesColumnToken(key, "ROTCHANGEFLG")) || "PDT_ROTCHANGEFLG";
        return String(isEmpty(source[flagKey]) ? "" : source[flagKey]).trim();
    }
    function isBrandHinbanNumberingControlledField(field) {
        if (isEmpty(field)) return false;
        const dataid = String(DicVal(field, "dataid", "")).trim().toUpperCase();
        const label = String(DicVal(field, "columnnm", "")).trim();
        return matchesColumnId(DicVal(field, "columnid", ""), "PDT_SYOHINCD") || dataid === "UNUSENO" || label === "ブランド品番連番";
    }
    function currentFixedHinbanNumberingValue() {
        if (!isEmpty(fixedHinbanNumberingValue)) return fixedHinbanNumberingValue;
        const source = props.entrydataRef.current;
        if (isEmpty(source)) return "";
        const key = Object.keys(source).find((dataKey) => matchesColumnId(dataKey, "__hinban_numbering_select__")) || "__hinban_numbering_select__";
        return String(isEmpty(source[key]) ? "" : source[key]).trim();
    }
    function fieldReadOnly(field) {
        if (matchesColumnToken(field.columnid, "ROTROUND")) {
            const flagValue = currentRotChangeFlag();
            if (flagValue === "0") return true;
            if (flagValue === "1") return false;
        }
        if (isBrandHinbanNumberingControlledField(field)) {
            if (field.locked) return true;
            const numberingValue = currentFixedHinbanNumberingValue();
            if (numberingValue === "1") return false;
            if (numberingValue === "0") return true;
        }
        if (field.editableOnNewFormOnly) {
            return effectiveFormStatus !== 'NEW FORM' || !!field.locked;
        }
        return !!DicVal(field, "manualInputLocked", false) || field.locked || ((field.primary || field.unchange) && effectiveFormStatus === 'ENTRY FORM');
    }
    function commandEnabled(field) {
        if (matchesColumnToken(field.columnid, "ROTROUND")) {
            return currentRotChangeFlag() === "1";
        }
        if (!!DicVal(field, "manualInputLocked", false)) return true;
        return !fieldReadOnly(field);
    }
    function displayFieldLabel(field) {
        if (effectiveFormStatus === 'NEW FORM' && matchesColumnId(field.columnid, 'PDT_SYOHINCD')) {
            return '★ ブランド品番';
        }
        return field.columnnm;
    }
    // SortableElement/SortableContainer をレンダー毎に作り直すと別のコンポーネント型と
    // 見なされ、配下の入力欄が全て再マウント(一瞬空白表示)される。
    // 型は初回のみ生成し、描画内容は ref 経由で常に最新の閉包を使う。
    const sortableItemRenderRef = useRef(null);
    sortableItemRenderRef.current = ({ value }) => (
        <div style={{ boxSizing: 'border-box', width: width(value.width), border: 'solid 1px #ccc' }}>
            <div className='fieldlabel' style={{ cursor: 'context-menu', backgroundColor: themestyle.header.back, color: themestyle.header.color, userSelect: 'none', fontSize: labelfontsize(displayFieldLabel(value))}}>
                {displayFieldLabel(value)}
            </div>
            < div className={'fieldinput'} style={{ position: 'relative', backgroundColor: fieldReadOnly(value) ? '#eee' : (value.required ? themestyle.body.require : 'inset') }}>
                <HinbanEntryInput
                    def={value}
                    dataRef={props.entrydataRef}
                    textfields={props.textfields}
                    fnc={props.fnc}
                    changewidth={ChangeWidth}
                    ValueChanged={props.ValueChanged}
                    QuerySearchClick={props.QuerySearchClick}
                    sectionLock={props.sectionLock}
                    commandEnabled={commandEnabled(value)}
                    forceNewFormMode={props.forceNewFormMode}
                    ignoreStoreEntryData={props.ignoreStoreEntryData}
                />
                {warning(value) ? <WarnTip msg={warndescription.find(e => e.rowid === "0" && e.col === value.columnid).message} conv={false} /> : null}
            </div >
        </div>
    );
    const SortableItem = useMemo(() => SortableElement((p) => sortableItemRenderRef.current(p)), []);
    const sortableListRenderRef = useRef(null);
    sortableListRenderRef.current = ({ items }) => {
        return (
            <div style={{ display: "flex", flexWrap: "wrap", justifyContent: 'left' }}>
                {items.map((value, index) => (
                    <SortableItem key={`${value.columnid}_${value.type}`} index={index} value={value} disabled={props.layoutlock} />
                ))}
            </div>
        );
    };
    const SortableList = useMemo(() => SortableContainer((p) => sortableListRenderRef.current(p)), []);

    const onSortEnd = ({ oldIndex, newIndex }, e) => {
        let type = e.target.parentNode.id.replace('basepanel', '');
        let idx = 0;
        for (let i = 0; i < props.textfields.length; i++) {
            if (props.textfields[i].type === type) {
                idx = i; break;
            }
        };
        props.settextfields(arrayMove(props.textfields, oldIndex + idx, newIndex + idx));
    };
    function shouldCancelStart(e) {
        if (e.target.className !== 'fieldlabel') return true;
    }

    return (
        isEnabled(props.showimage) ?
            <div style={{ display: 'grid', gridTemplateColumns: windowDimensions.width <= 1000 ? '1fr 1fr' : '1fr 3fr' }}>
                <div style={{ paddingRight: 5, gridRow: '1/3' }}>
                    <Paper
                        style={{
                            width: '100%',
                            height: 'auto',
                            padding: 10,
                            display: 'flex',
                            justifyContent: 'center'
                        }}
                    >
                        <img src={imgsrc}
                            style={{ maxWidth: '100%', height: 'auto', objectFit: 'cover' }}
                            onDoubleClick={sectionLock ? undefined : ImageDialog}
                            draggable={false}
                        />
                    </Paper>
                </div>
                <div>
                    < SortableList
                        axis = { "xy"}
                        items = { props.textfields.filter(e => e.type === props.panel.type) }
                        onSortEnd = { onSortEnd }
                        distance = { 1}
                        shouldCancelStart = { shouldCancelStart }
                    />
                </div>
                {images.length > 1 ?
                    <div style={{ alignSelf: 'end' }}>
                        {images.map((value, index) => (
                            <img src={value.imageurl}
                                style={{ width: 70, height: 70, objectFit: 'cover', border: imgindex === index ? '3px solid #4fbce4' :'1px solid #ccc', margin: 3, cursor: sectionLock ? 'default' : 'pointer' }}
                                onClick={() => imageChange(index)}
                                draggable={false}
                                />
                        ))}
                    </div>
                : null}
            </div>
        :
        <SortableList
            axis={"xy"}
            items={props.textfields.filter(e => e.type === props.panel.type)}
            onSortEnd={onSortEnd}
            distance={1}
            shouldCancelStart={shouldCancelStart}
        />
    );
}



